import { createVar, style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

const { sheet } = semanticThemeTokens;

const transitionDuration = createVar();

export const noDuration = style({
  vars: {
    [transitionDuration]: "0s"
  }
});

export const defaultDuration = style({
  vars: {
    [transitionDuration]: sheet.transitionDuration
  }
});

export const sheetStyle = style({
  position: "relative",
  backgroundColor: sheet.layer1.backgroundColor,
  padding: primitiveTokens.sizing["2.5x"],
  minHeight: primitiveTokens.sizing["6x"],
  borderTopLeftRadius: primitiveTokens.sizing["4x"],
  borderTopRightRadius: primitiveTokens.sizing["4x"],
  width: "100%",
  overflow: "hidden",
  transitionProperty: "flex, width",
  transitionDuration: transitionDuration,
  flex: "none",

  selectors: {
    "&:first-child:not(:only-child)": {
      padding: primitiveTokens.sizing["2.5x"]
    },
    "&:not(:nth-last-child(-n + 3))": {
      display: "none"
    },
    '&:nth-last-child(3), &:nth-last-child(2):first-child[data-collapsed="true"]':
      {
        width: `calc(100% - ${primitiveTokens.sizing["16x"]})`
      },
    "&:nth-last-child(2)": {
      // Second last sheet should have width of 100% minus padding
      width: `calc(100% - ${primitiveTokens.sizing["8x"]})`
    },
    "&:last-child": {
      flex: 1
    },
    "&:nth-last-child(2):not(:first-child), &:nth-child(2):last-child": {
      backgroundColor: sheet.layer2.backgroundColor
    },
    "&:last-child:not(:nth-child(-n + 2))": {
      backgroundColor: sheet.layer3.backgroundColor
    },
    "&:not(:first-child):nth-last-child(-n + 2)": {
      boxShadow: sheet.shadow
    }
  }
});

// Wrapper for animating the height of the content using grid
// https://keithjgrant.com/posts/2023/04/transitioning-to-height-auto/#with-grid
export const sheetContentStyle = style({
  display: "grid",
  gridTemplateRows: "1fr",
  height: "100%",
  transitionBehavior: "allow-discrete",
  transitionDuration: transitionDuration,
  transitionProperty: "grid-template-rows, opacity",
  selectors: {
    [`${sheetStyle}:not(:nth-last-child(-n + 2)) > &, ${sheetStyle}:nth-last-child(2)[data-collapsed="true"] > &`]:
      {
        opacity: 0,
        gridTemplateRows: "0fr"
      }
  }
});

export const sheetContentInnerStyle = style({
  display: "block",
  overflowX: "hidden",
  overflowY: "auto",
  opacity: 1,
  transitionBehavior: "allow-discrete",
  transitionProperty: "display, opacity",
  transitionDuration: transitionDuration,
  selectors: {
    // Hide the content of the sheet if it is not the last two sheets OR if it is the second last sheet and collapsed
    [`${sheetStyle}:not(:nth-last-child(-n + 2)) > ${sheetContentStyle} > &, ${sheetStyle}:nth-last-child(2)[data-collapsed="true"] > ${sheetContentStyle} > &`]:
      {
        display: "none"
      }
  }
});

export const containerStyle = style({
  position: "absolute",
  inset: 0,
  display: "flex",
  zIndex: 1,
  width: "100%",
  flexDirection: "column",
  alignItems: "center"
});
